<div class="trackCard" [ngClass]="{'isSearch': isSearch}">
  <div style="display: flex;">

    <div class="previewSection blueColorHover" style="text-align: center;" (click)="handleShowFullScreenImage()">
      <img *ngIf="!trackItem.preview" src="assets/track.PNG" alt="utwór" width="90" height="90">
      <img *ngIf="trackItem.preview" src="{{previewUrl}}/m_{{trackItem.preview}}" alt="utwór" width="90" height="90">
      <div class="p-grid marginzero p-justify-center">
        <span style="font-size: 15px; font-weight: 500;">{{ 'track_preview' | translate }}</span>
      </div>
    </div>

    <div class="mainSection">

      <a routerLink="/note/{{trackItem.id}}/{{trackItem.slug}}"  class="blueColorHover cardTitle" style="margin-bottom: 5px;">
         {{ trackItem.title }}
      </a>

      <div class="grayColor" style="margin-bottom: 10px;">
        <span>{{ trackItem?.arranger?.user_details?.name }} {{ trackItem?.arranger?.user_details?.surname }}</span>
        <span *ngIf="trackItem.categories && trackItem.categories.length > 0"> / </span>
        <span *ngIf="trackItem.categories && trackItem.categories.length > 0">{{displayCategories(trackItem.categories)}}</span>
      </div>

      <div *ngIf="trackItem.rating" class="rateContainer">
        <div class="blueBackground rate">{{ trackItem.rating }}</div>
        <div class="grayColor rateLabel">{{ 'tile_rating' | translate }}</div>
      </div>

      <!-- <audio *ngIf="playClicked" controls>
        <source [src]="playSrc | safeHtml" type="audio/mpeg">
      </audio> -->
      <app-audio-player *ngIf="playClicked" [src]="playSrc"></app-audio-player>
      <button *ngIf="!playClicked" class="playButton blueColor" (click)="playAudio()">
        <div class="playButtonIcon"><i class="pi pi-caret-right"></i></div>
        <div class="listen">{{ 'tile_listen' | translate }}</div>
      </button>

    </div>

  <div class="rateCardSection">
    <div style="margin-bottom: 10px;">
      <div class="grayColor level">{{ 'title_level' | translate }}</div>
      <app-note-level [levelFilter]="trackItem.level" [readOnly]="true" [small]="true"></app-note-level>
    </div>

    <div class="smallCard">
      <div class="blueColor price">{{'tile_price' | translate}}: <span style="font-weight: 500;">{{ trackItem.price | currencyReduce | currency: selectedCurrency }}</span></div>
      <app-primary-button [item]="trackItem" (action)="addToCart()" label="{{ 'track_to_cart' | translate }}"></app-primary-button>
    </div>

    <div class="mobilePreviewSection blueColorHover" (click)="handleShowFullScreenImage()">
      <i class="pi pi-eye"></i>
      <span>{{ 'track_preview' | translate }}</span>
    </div>
  </div>

  </div>
</div>

<p-dialog *ngIf="fullScreenImageMode && trackItem && trackItem.preview"  header="{{ 'track_preview' | translate }}" [(visible)]="fullScreenImageMode" [style]="{width: previewWidth}" [baseZIndex]="10000">
  <img src="{{previewUrl}}/{{trackItem?.preview}}" style="width: 100%;" />
  <!-- <img src="assets/note_mock.jpg" style="width: 100%;" /> -->
</p-dialog>
